import { MARKETING, SALES, SERVICE, CMS } from 'self-service-api/constants/ProductLines';
export const signupEligibleProductLines = [MARKETING, SALES, SERVICE, CMS];